import { render, staticRenderFns } from "./MovePost.vue?vue&type=template&id=748fc3c6&scoped=true&"
import script from "./MovePost.vue?vue&type=script&lang=js&"
export * from "./MovePost.vue?vue&type=script&lang=js&"
import style0 from "./MovePost.vue?vue&type=style&index=0&id=748fc3c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fc3c6",
  null
  
)

export default component.exports